var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23096 8.92302H14.3079C14.554 8.92302 14.7694 8.70764 14.7694 8.46148V7.53841C14.7694 7.29225 14.554 7.07687 14.3079 7.07687H9.23096C9.04634 7.07687 8.92326 6.95379 8.92326 6.76917V1.69225C8.92326 1.4461 8.70788 1.23071 8.46173 1.23071H7.53865C7.2925 1.23071 7.07711 1.4461 7.07711 1.69225V6.76917C7.07711 6.95379 6.95403 7.07687 6.76942 7.07687H1.6925C1.44634 7.07687 1.23096 7.29225 1.23096 7.53841V8.46148C1.23096 8.70764 1.44634 8.92302 1.6925 8.92302H6.76942C6.95403 8.92302 7.07711 9.0461 7.07711 9.23071V14.3076C7.07711 14.5538 7.2925 14.7692 7.53865 14.7692H8.46173C8.70788 14.7692 8.92326 14.5538 8.92326 14.3076V9.23071C8.92326 9.0461 9.04634 8.92302 9.23096 8.92302Z",
    fill: "#C8172F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRed);
export default __webpack_public_path__ + "static/media/plusRed.ab2162314974db0f0806e09e7d33ab26.svg";
export { ForwardRef as ReactComponent };